import { FC } from 'react';
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import RequestList from '../../requests/RequestList';
import { DashHeading } from '../DashboardPage';
import { fetchRequestsList } from '../../requests/requestTypes';

const RequestsPage: FC = () => {
  const { t } = useTranslation();
  const { data = [] } = useQuery(
    'ActiveRequestsList',
    () => fetchRequestsList(true)
  );

  return (
    data.length > 0 && (
      <div>
        <DashHeading>{t('Nog te doen')}</DashHeading>
        <RequestList data={data} />
      </div>
    )
  );
};

export default RequestsPage;
